<template>
  <div>c</div>
    
</template>

<script>
// import axios from 'axios'
export default {
  created(){
    //   console.log(this.$route)
    window.localStorage.clear()
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
